module.exports = __webpack_public_path__ + "static/media/twitter.6f82fc3b.svg";